// constants/provinces.js

const provinces = [
  { id: 1, name: "اراک", sunriseVal: 24, sunsetVal: 74 },
  { id: 2, name: "اردبیل", sunriseVal: 25, sunsetVal: 75 },
  { id: 3, name: "ارومیه", sunriseVal: 26, sunsetVal: 76 },
  { id: 4, name: "اصفهان", sunriseVal: 27, sunsetVal: 77 },
  { id: 5, name: "اهواز", sunriseVal: 28, sunsetVal: 78 },
  { id: 6, name: "ایلام", sunriseVal: 29, sunsetVal: 79 },
  { id: 7, name: "بجنورد", sunriseVal: 30, sunsetVal: 80 },
  { id: 8, name: "بندرعباس", sunriseVal: 31, sunsetVal: 81 },
  { id: 9, name: "بوشهر", sunriseVal: 32, sunsetVal: 82 },
  { id: 10, name: "بیرجند", sunriseVal: 33, sunsetVal: 83 },
  { id: 11, name: "تبریز", sunriseVal: 34, sunsetVal: 84 },
  { id: 12, name: "تهران", sunriseVal: 35, sunsetVal: 85 },
  { id: 13, name: "خرم‌آباد", sunriseVal: 36, sunsetVal: 86 },
  { id: 14, name: "رشت", sunriseVal: 37, sunsetVal: 87 },
  { id: 15, name: "زاهدان", sunriseVal: 38, sunsetVal: 88 },
  { id: 16, name: "زنجان", sunriseVal: 39, sunsetVal: 89 },
  { id: 17, name: "ساری", sunriseVal: 40, sunsetVal: 90 },
  { id: 18, name: "سمنان", sunriseVal: 41, sunsetVal: 91 },
  { id: 19, name: "سنندج", sunriseVal: 42, sunsetVal: 92 },
  { id: 20, name: "شهرکرد", sunriseVal: 43, sunsetVal: 93 },
  { id: 21, name: "شیراز", sunriseVal: 44, sunsetVal: 94 },
  { id: 22, name: "قزوین", sunriseVal: 45, sunsetVal: 95 },
  { id: 23, name: "قم", sunriseVal: 46, sunsetVal: 96 },
  { id: 24, name: "کرج", sunriseVal: 47, sunsetVal: 97},
  { id: 25, name: "کرمان", sunriseVal: 48, sunsetVal: 98 },
  { id: 26, name: "کرمانشاه", sunriseVal: 49, sunsetVal: 99 },
  { id: 27, name: "گرگان", sunriseVal: 50, sunsetVal: 100 },
  { id: 28, name: "مشهد", sunriseVal: 51, sunsetVal: 101 },
  { id: 29, name: "همدان", sunriseVal: 52, sunsetVal: 102 },
  { id: 30, name: "یاسوج", sunriseVal: 53, sunsetVal: 103 },
  { id: 31, name: "یزد", sunriseVal: 54, sunsetVal: 104 },
];

export default provinces;
